import { JobbinInputGreyProps } from "../jobbinInputGrey/model"
import PropTypes from "prop-types"
import "../style.css"

export const JobbinInputGrey = (props: JobbinInputGreyProps) => {
    return (
        <div className="flex w-full flex-col">
            {props.label ? (
                <label
                    className="jobbin-input-label mb-3 text-start text-sm sm:text-base text-figmaPrimary"
                    htmlFor={props.name}
                >
                    {props.label}
                    {props.required ? <span className="text-figmaPrimary"> *</span> : null}
                </label>
            ) : null}

            <input
                id={props.name}
                name={props.name}
                type={props.type}
                placeholder={props.placeholder}
                value={props.value ? props.value : ""}
                onChange={props.onChange}
                min={props.min}
                disabled={props.disabled}
                className={`jobbin-input jobbin-input-gray-bg w-full rounded-[12px] py-[14px] px-[20px] text-[16px] text-figmaBlack ${
                    props.disabled ? "opacity-40 cursor-not-allowed" : ""
                } ${props.classNames ? props.classNames : ""}`}
                style={
                    props.iconStart
                        ? {
                            backgroundImage: `url(/images/${props.iconStart})`,
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "left 20px center",
                            paddingLeft: "52px",
                        }
                        : props.iconEnd
                            ? {
                                backgroundImage: `url(/images/${props.iconEnd})`,
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "right 20px center",
                                paddingRight: "52px",
                            }
                            : {}
                }
            />
        </div>
    )
}

JobbinInputGrey.propTypes = {
    placeholder: PropTypes.string,
    name: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    min: PropTypes.string,
}